import blackChair from "./assets/blackChair_.png";
import greenSofa from "./assets/greenSofa_.png";
import mirror from "./assets/mirror_.png";
import table from "./assets/table_.png";
import whiteChair from "./assets/whiteChair_.png";
import officeChair from "./assets/officeChair_.png";
import brownTable from "./assets/brown-table-.png";
import chairblack from "./assets/chairblack-.png";
import pinksofa from "./assets/pinksofa-.png";
import yellowsofa from "./assets/yellowsofa-.png";

const Data = [
  {
    id: "1",
    title: "chair",
    price: `$45.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: whiteChair,
    category: "living",
    available: 9,
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
  {
    id: "2",
    title: "office comfy chair.",
    price: `$33.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: officeChair,
    available: 11,
    category: "office",
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
  {
    id: "3",
    title: " green couch sofa",
    price: `$450.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: greenSofa,
    available: 4,
    category: "living",
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
  {
    id: "4",
    title: "cafe table ",
    price: `$100.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: table,
    category: "dining",
    available: 13,
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
  {
    id: "5",
    title: "Wooden Framed  Mirror ",
    price: `$40.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: mirror,
    available: 10,
    category: "bedroom",
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
  {
    id: "6",
    title: " Black Chair ",
    price: `$50.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: blackChair,
    category: "office",
    available: 8,
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },

  {
    id: "7",
    title: "Broma Bed Side Table ",
    price: `$70.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: "https://furns-react.netlify.app/_next/image?url=https%3A%2F%2Fcdn.shopify.com%2Fs%2Ffiles%2F1%2F0597%2F8970%2F5392%2Fproducts%2F5_c8625a3e-4a89-478d-8f51-b5b5d6b1057a.jpg%3Fv%3D1632549533&w=1920&q=75",
    available: 5,
    category: "lounge",
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
  {
    id: "8",
    title: "Twist Dining Table ",
    price: `$250.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: "https://furns-react.netlify.app/_next/image?url=https%3A%2F%2Fcdn.shopify.com%2Fs%2Ffiles%2F1%2F0597%2F8970%2F5392%2Fproducts%2F1_d9913561-510c-4d82-8185-4e4fd3828742.jpg%3Fv%3D1632545251&w=1920&q=75",
    available: 14,
    category: "dining",
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
  {
    id: "9",
    title: "Small Table ",
    price: `$25.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: brownTable,
    category: "lounge",
    available: 10,
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
  {
    id: "10",
    title: "Chair",
    price: `$30.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: chairblack,
    category: "office",
    available: 12,
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
  {
    id: "11",
    title: " Pink Sofa",
    price: `$70.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: pinksofa,
    category: "living",
    available: 8,
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
  {
    id: "12",
    title: "Yellow Sofa",
    price: `$75.0`,
    desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
    img: yellowsofa,
    category: "living",
    available: 10,
    color: {
      b: "blue",
      g: "green",
      r: "red",
      y: "yellow",
      bl: "black",
      w: "white",
    },
  },
];
export default Data;
